<template>
  <div class="next-back">
    <div :class="{ 'fixed-bottom': !relative }">
      <div class="row text-right" :class="{ 'navigation-bottom': showBackground }">
        <div
          class="pt-3 pb-3"
          :class="{
            'small-container': !relative,
            container: relative && paddingLR,
            'container-fluid': relative && !paddingLR,
            'pr-5': relative && paddingLR,
            'pl-5': relative && paddingLR,
          }"
        >
          <div class="row align-items-center">
            <div v-if="displayBack" class="col text-left pl-8" :class="{ 'pl-0': !paddingLR }">
              <hl-Button
                :outline="backOutline"
                :variant="backVariant"
                @click="onBack()"
                :disabled="disabled"
                data-cy="app-funnel-button-back"
              >
                {{ backText }}
              </hl-Button>
            </div>

            <div v-if="displayNext" class="col text-right pr-8" :class="{ 'pr-0': !paddingLR }">
              <router-link
                :to="{ name: nextLink, params }"
                :disabled="disabled || nextDisabled"
                @click.native="onNext()"
                tag="button"
                class="btn"
                :class="nextButtonClass"
                data-cy="app-funnel-button-next"
              >
                <span v-if="isTypeObject(nextText)">
                  <hl-LoaderDots v-if="nextText.isLoading" variant="white"></hl-LoaderDots>
                  <span v-else>{{ nextText.text }}</span>
                </span>
                <span v-if="isTypeString(nextText)">{{ nextText }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@modules/husleie-framework/src/components/buttons/Button.vue';
import LoaderDots from '@modules/husleie-framework/src/components/loaders/LoaderDots.vue';

export default {
  name: 'next-back-bottom-bar',

  components: {
    'hl-Button': Button,
    'hl-LoaderDots': LoaderDots,
  },

  props: {
    buttonSize: {
      type: String,
      default: 'lg',
    },
    backOutline: {
      type: Boolean,
      default: true,
    },
    backVariant: {
      type: String,
      default: 'secondary',
    },
    nextVariant: {
      type: String,
      default: 'primary',
    },
    color: {
      // legacy, to be replaced with nextColor
      type: String,
      default: 'primary',
    },
    nextLink: {
      type: String,
    },
    nextText: {
      type: [String, Object],
    },
    backLink: {
      type: String,
    },
    backText: String,
    params: Object,
    nextDisabled: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    displayBack: {
      type: Boolean,
      default: true,
    },
    displayNext: {
      type: Boolean,
      default: true,
    },
    relative: {
      type: Boolean,
      default: false,
    },
    showBackground: {
      type: Boolean,
      default: true,
    },
    paddingLR: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    nextButtonClass() {
      return this.nextVariant ? `btn-${this.nextVariant}` : `btn-${this.color}`;
    },
  },
  methods: {
    onBack() {
      this.$emit('backEvent');

      if (this.backLink) {
        this.navigateBack();
      }
    },
    onNext() {
      this.$emit('nextEvent');
    },
    navigateBack() {
      if ('_hlPrevValidPage' in window && window._hlPrevValidPage === this.backLink) {
        this.$router.back();
      } else {
        // Husleie/tss-restlist#76 - Not resetting this value on navigating back to
        // pages not matching the rule above can result in calling back in some cases
        // where it would send you to a page you did not expect. If we do a navigation here,
        // make sure to delete PrevValidPage from window.
        if ('_hlPrevValidPage' in window) delete window._hlPrevValidPage;

        this.$router.push({ name: this.backLink, params: this.params });
      }
    },

    isTypeString(val) {
      return typeof val === 'string';
    },

    isTypeObject(val) {
      return typeof val === 'object';
    },
  },
};
</script>

<style lang="css">
.navigation-bottom {
  background: #f8f8f8;
}
body .fixed-bottom {
  display: block;
}
body.modal--open .fixed-bottom {
  display: none;
  z-index: 1;
}
</style>
